export const statesKeys = {
	states: (countryId: number) => ["states", countryId] as const,
};
